import styled from 'styled-components';
import { themed } from '@/shared/ui/core';

export const InputWrapper = styled.div.attrs({
  className: 'Input__Date',
})`
  align-items: center;
  border: 1px solid ${themed('common.borderColor')};
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  padding: 0 0.75rem 0 0;

  svg {
    max-width: 1.5rem;
  }

  .InputStyled {
    border: 0;
    margin-bottom: 0;
    overflow: hidden;
    padding-left: 0.75 !important;
    text-overflow: ellipsis;
    width: 100%;
  }
`;
